import { render, staticRenderFns } from "./DeclarationsWidget.vue?vue&type=template&id=2d169274&scoped=true"
import script from "./DeclarationsWidget.vue?vue&type=script&lang=js"
export * from "./DeclarationsWidget.vue?vue&type=script&lang=js"
import style0 from "./DeclarationsWidget.vue?vue&type=style&index=0&id=2d169274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d169274",
  null
  
)

export default component.exports